import { render, staticRenderFns } from "./EmailVerify.vue?vue&type=template&id=5c633f0b&scoped=true&"
import script from "./EmailVerify.vue?vue&type=script&lang=ts&"
export * from "./EmailVerify.vue?vue&type=script&lang=ts&"
import style0 from "./EmailVerify.vue?vue&type=style&index=0&id=5c633f0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c633f0b",
  null
  
)

export default component.exports